import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const UserIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

const MailIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
  </svg>
);

const QuoteIcon = () => (
  <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M9.17 6C5.87 6 3.2 8.67 3.2 11.97c0 2.59 1.65 4.79 3.96 5.6.42.14.84-.18.84-.62v-.95c0-.22-.12-.42-.31-.52-1.18-.6-1.99-1.82-1.99-3.25 0-1.97 1.53-3.58 3.47-3.7.47-.03.83-.42.83-.89V6.89c0-.49-.4-.89-.89-.89H9.17zm9 0c-3.3 0-5.97 2.67-5.97 5.97 0 2.59 1.65 4.79 3.96 5.6.42.14.84-.18.84-.62v-.95c0-.22-.12-.42-.31-.52-1.18-.6-1.99-1.82-1.99-3.25 0-1.97 1.53-3.58 3.47-3.7.47-.03.83-.42.83-.89V6.89c0-.49-.4-.89-.89-.89h-.94z" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
  </svg>
);

const PrincipalMessagePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main id="main-content" className="pt-0">
        {/* Hero */}
        <section
          className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden"
        >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

          <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <span className="text-sm font-semibold text-white tracking-tight">
                  About Us
                </span>
              </div>
            </div>
            <h1
              className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              Principal&apos;s Message
            </h1>
            <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mx-auto">
              A welcome note from Mr. Konstantinakos, Principal of PS 96 —
              Joseph C. Lanzetta School of the Arts, Collaboration &amp;
              Technology.
            </p>
          </div>
        </section>

        {/* Letter */}
        <section className="max-w-4xl mx-auto px-6 lg:px-8 -mt-10 mb-20 relative z-10">
          <article className="bg-white border border-gray-200 rounded-xl shadow-md p-8 lg:p-12">
            <div className="flex items-start gap-6 mb-8 pb-8 border-b border-gray-100">
              <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-[#fdbb2e] to-[#fdc951] flex items-center justify-center flex-shrink-0 shadow-sm text-[#00213a]">
                <UserIcon />
              </div>
              <div>
                <h2
                  className="text-2xl font-semibold text-gray-900 mb-1 tracking-tight"
                  style={{ letterSpacing: '-0.02em' }}
                >
                  Mr. Konstantinakos
                </h2>
                <p className="text-sm text-gray-600 font-medium">
                  Principal, PS 96 ACT
                </p>
              </div>
            </div>

            <div className="relative">
              <div
                className="absolute -top-2 -left-2 text-[#fdbb2e]/30 pointer-events-none"
                aria-hidden="true"
              >
                <QuoteIcon />
              </div>

              <div className="space-y-5 text-gray-700 leading-relaxed text-lg pl-6">
                <h3 className="text-2xl font-semibold text-[#00213a] tracking-tight" style={{ letterSpacing: '-0.02em' }}>
                  Welcome Back, P.S. 96 Families and Students!
                </h3>
                <p>
                  We are thrilled to welcome everyone back to P.S. 96 for
                  another exciting and successful school year! The hallways are
                  once again filled with energy, enthusiasm, and the joy of
                  learning, and we are grateful to have our students and
                  families back with us.
                </p>
                <p>
                  As we begin this new journey together, we look forward to
                  providing a safe, supportive, and engaging environment where
                  every child can learn, grow, and thrive. Our dedicated staff
                  is committed to helping each student reach their full
                  potential while fostering curiosity, creativity, kindness,
                  and a love of learning.
                </p>
                <p>
                  Thank you for your continued partnership and support.
                  Together, we can make this school year a rewarding and
                  memorable experience for all. We encourage our students to
                  embrace new opportunities, challenge themselves, and always
                  be their best selves.
                </p>
                <p>
                  Here&apos;s to a wonderful year filled with learning,
                  achievement, and community!
                </p>
                <p className="text-xl font-semibold text-[#00213a]">
                  Welcome back, and let&rsquo;s make it a fantastic year at
                  P.S. 96!
                </p>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-100">
              <p className="text-gray-900 font-medium">Sincerely,</p>
              <p
                className="text-2xl font-semibold text-[#00213a] tracking-tight mt-1"
                style={{ letterSpacing: '-0.02em' }}
              >
                Mr. Konstantinakos
              </p>
              <a
                href="mailto:jkonstantinakos@schools.nyc.gov"
                className="inline-flex items-center gap-2 mt-4 text-sm text-[#00213a] hover:underline font-medium"
                aria-label="Email Principal Konstantinakos"
              >
                <MailIcon />
                jkonstantinakos@schools.nyc.gov
              </a>
            </div>
          </article>
        </section>

        {/* Related links */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <h2
              className="text-2xl font-semibold text-gray-900 mb-8 tracking-tight text-center"
              style={{ letterSpacing: '-0.02em' }}
            >
              Learn more about PS 96
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <Link
                to="/faculty/james-konstantinakos"
                className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md hover:border-[#fdbb2e]/40 transition-all duration-200"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-[#00213a]">
                  Principal Profile
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Full contact details for Mr. Konstantinakos in our staff
                  directory.
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-[#00213a] group-hover:gap-2 transition-all" aria-hidden="true">
                  View Profile <ArrowRightIcon />
                </span>
              </Link>

              <Link
                to="/directory/faculty"
                className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md hover:border-[#fdbb2e]/40 transition-all duration-200"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-[#00213a]">
                  Faculty &amp; Staff
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Meet the administrators, teachers, and support staff at PS 96.
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-[#00213a] group-hover:gap-2 transition-all" aria-hidden="true">
                  Browse Directory <ArrowRightIcon />
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrincipalMessagePage;
